import { render, staticRenderFns } from "./PromotionWidget.vue?vue&type=template&id=7a1c0f1a&"
import script from "./PromotionWidget.vue?vue&type=script&lang=js&"
export * from "./PromotionWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports